module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition-group', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": "animated-fast fadeInUp",
      "leave-active-class": "animated-fast fadeOutBottom"
    }
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "card"
    }, [_c('header', {
      staticClass: "card-header"
    }, [_c('p', {
      staticClass: "card-header-title"
    }, [_vm._v("\n      " + _vm._s(message.author) + "\n    ")])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(message.text)
      }
    })])])]), _vm._v(" "), _c('br')])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49c1ddd2"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat-list-xss.vue
// module id = 127
// module chunks = 1